<template>
    <div v-if="activeSite">
        <h3 class="mb-4">
            Calificaciones
            <b-button
                v-if="isUserStudenTeacherOrBetter"
                class="ml-2"
                variant="primary"
                :disabled="!getActiveSiteGrades || !getActiveSiteSectionOptions"
                @click="onDownloadAllGrades()"
            >
                <b-icon-download /> Descargar Todas
            </b-button>
        </h3>

        <SingleStudentGrades v-if="dataLoaded && isUserStudentInCurrentSite" />

        <UpdateStudentGrades v-if="dataLoaded && isUserStudenTeacherOrBetter" />

    </div>
</template>

<script>
import SingleStudentGrades from './SingleStudentGrades'
import UpdateStudentGrades from './UpdateStudentGrades'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'SiteGrades',
    components: {
        SingleStudentGrades,
        UpdateStudentGrades
    },
    data () {
        return {
            dataLoaded: false
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'isUserStudentInCurrentSite',
            'isUserStudenTeacherOrBetter',
            'getActiveSiteGrades',
            'getActiveSiteSectionOptions'
        ])
    },
    methods: {
        ...mapActions([
            'readSingleStudentGrades',
            'readCourseSiteGrades',
            'readAllGradesDownloadData'
        ]),
        async onDownloadAllGrades () {
            try {
                var blobData = await this.readAllGradesDownloadData(this.activeSite.id)
                var fileURL = window.URL.createObjectURL(new Blob([blobData]))
                var fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute(
                    'download',
                    `Calificaciones ${this.activeSite.course.name} ${this.activeSite.semester.academic_period}.xlsx`
                )
                document.body.appendChild(fileLink)
                fileLink.click()
            } catch (err) {
                console.log(err)
                this.$root.unknownErrorToast()
            }
        }
    },
    async created () {
        let loader = null
        this.dataLoaded = false
        try {
            loader = this.$loading.show()
            if (this.isUserStudentInCurrentSite) {
                await this.readSingleStudentGrades(this.activeSite.id)
            } else if (this.isUserStudenTeacherOrBetter) {
                await this.readCourseSiteGrades(this.activeSite.id)
            }
            this.dataLoaded = true
        } catch (err) {
            console.log(err)
            this.dataLoaded = false
            this.unknownErrorToast()
        } finally {
            loader.hide()
        }
    }
}
</script>
